import lightbox from 'lightbox2'

lightbox.option({
  resizeDuration: 50,
  imageFadeDuration: 20,
  wrapAround: true,
  alwaysShowNavOnTouchDevices: true
})
